import {IStateProps} from './model';
import * as React from 'react';
import {Button} from '../../../../../../../shared/components/button';
import {useStyles} from '../../../../../../../shared/hooks/styles';

export default ({isChecked, onPress, label, style, name}: IStateProps) => {
  const styles = useStyles(() => ({
    button: {height: 'auto', minHeight: 40},
    buttonText: {textAlign: 'center'},
  }));
  return (
    <Button
      id={`profile-applications-filter-${name}`}
      style={[styles.button, style]}
      textStyle={styles.buttonText}
      block
      type={isChecked ? 'primary' : 'secondary'}
      text={label}
      onPress={onPress}
    />
  );
};
